import PickersList from './PickersList.vue'

export default PickersList
